import { useState } from "react";
import { Helmet } from "react-helmet-async";
import TrueWellnessHeader from "@/components/truewellness/TrueWellnessHeader";
import TrueWellnessFooter from "@/components/truewellness/TrueWellnessFooter";
import EmployerLeadModal from "@/components/employers/EmployerLeadModal";
import EmployerHero from "@/components/employers/EmployerHero";
import EmployerStats from "@/components/employers/EmployerStats";
import CostSavingsCalculator from "@/components/employers/CostSavingsCalculator";
import WhyTrueWellness from "@/components/employers/WhyTrueWellness";
import EmployeeTestimonial from "@/components/employers/EmployeeTestimonial";
import HealthBenefits from "@/components/employers/HealthBenefits";
import PlanTiers from "@/components/employers/PlanTiers";
import CSuiteOffering from "@/components/employers/CSuiteOffering";
import DentalVIPOffering from "@/components/employers/DentalVIPOffering";
import HowItWorks from "@/components/employers/HowItWorks";
import IntegrationBenefits from "@/components/employers/IntegrationBenefits";
import ComparisonTable from "@/components/employers/ComparisonTable";
import EmployerTestimonials from "@/components/employers/EmployerTestimonials";
import EmployerFAQ from "@/components/employers/EmployerFAQ";
import EmployerCTA from "@/components/employers/EmployerCTA";

const Employers = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Helmet>
        <title>Employer Benefits | True Wellness - GLP-1 & Peptide Programs for Companies</title>
        <meta 
          name="description" 
          content="Transform employee wellness with medical weight loss. GLP-1s, custom peptides, and comprehensive support starting at $74/month. Calculate your ROI today." 
        />
        <meta name="keywords" content="employer wellness, corporate weight loss, GLP-1 benefits, employee health, B2B healthcare" />
      </Helmet>

      <div className="min-h-screen bg-white">
        <TrueWellnessHeader onOpenModal={() => setIsModalOpen(true)} />
        
        <main>
          <EmployerHero onRequestDemo={() => setIsModalOpen(true)} />
          <EmployerStats />
          <PlanTiers onOpenModal={() => setIsModalOpen(true)} />
          <CostSavingsCalculator onOpenModal={() => setIsModalOpen(true)} />
          {/* <CSuiteOffering onOpenModal={() => setIsModalOpen(true)} /> */}
          {/* <DentalVIPOffering onOpenModal={() => setIsModalOpen(true)} /> */}
          {/* <EmployeeTestimonial /> */}
          <WhyTrueWellness />
          <ComparisonTable />
          <HealthBenefits />
          <HowItWorks />
          {/* <IntegrationBenefits /> */}
          {/* <EmployerTestimonials /> */}
          <EmployerFAQ />
          <EmployerCTA onRequestDemo={() => setIsModalOpen(true)} />
        </main>

        <TrueWellnessFooter />
        
        <EmployerLeadModal 
          open={isModalOpen} 
          onOpenChange={setIsModalOpen} 
        />
      </div>
    </>
  );
};

export default Employers;
